'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { useUser } from '@/app_lib/providers/UserProvider';
import { GoogleTagManager } from '@/app_lib/services/Gtm';
import type { PageAdConfig } from '@/app_lib/types/Ad';
import type { ArcSpanPageConfig } from '@/app_lib/types/ArcSpan';
import type { PageViewDataLayerObject } from '@/app_lib/types/Gtm';
import type { PianoPageConfig } from '@/app_lib/types/Piano';

export const Wrapper = ({
  children,
  pageConfig,
  arcSpanConfig,
  pageAdConfig,
  dataLayer,
  className = '',
}: {
  children?: React.ReactNode;
  pageConfig: PianoPageConfig;
  arcSpanConfig: ArcSpanPageConfig;
  pageAdConfig: PageAdConfig;
  dataLayer: PageViewDataLayerObject;
  className?: string;
}) => {
  const { setPianoPageConfig } = useUser();
  const { setPageAdConfig, setArcSpanPageConfig } = useAdContext();
  const gaId = process.env.EZ_NEWSWIRE_GA_ID;

  useEffect(() => {
    setPianoPageConfig(pageConfig);
    setArcSpanPageConfig(arcSpanConfig);
    setPageAdConfig(pageAdConfig);
  }, [setPianoPageConfig, pageConfig, arcSpanConfig, pageAdConfig, setPageAdConfig, setArcSpanPageConfig]);

  return (
    <div
      className={className}
      data-gap='false'
    >
      <GoogleTagManager dataLayer={dataLayer} />
      <>
        <Script
          src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
          strategy='afterInteractive'
        />

        <Script
          id='ez-newswire-ga'
          strategy='afterInteractive'
        >
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}');
          `}
        </Script>
      </>
      {children}
    </div>
  );
};
